import React from 'react';

import CatchError from './CatchError';
import NotFoundPage from '../error-pages/NotFoundPage/NotFoundPage';
import ServerErrorPage from '../error-pages/ServerErrorPage/ServerErrorPage';
import AccessDenied from '../error-pages/access-denied/AccessDenied';
import MaintenanceErrorPage from '../error-pages/MaintenanceErrorPage/MaintenanceErrorPage';

const ErrorBoundary = CatchError(function (props, errorStatus) {
  if (errorStatus === 404) {
    return <NotFoundPage />;
  }
  if (errorStatus === 500) {
    return <ServerErrorPage />;
  }
  if (errorStatus === 599) {
    return <MaintenanceErrorPage />;
  }
  if (errorStatus === 403) {
    return <AccessDenied />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
});

export default ErrorBoundary;
